import React from 'react';

function SectionTitle({ children }) {
  return <h2 className="section-title">{children}</h2>;
}

export default SectionTitle;
